import React, { useState, useEffect, useReducer } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

axios.defaults.timeout = 30000;

const apiReducer = (state, action) => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case 'SUCCESS':
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    case 'FAILURE':
      return {
        ...state,
        isLoading: false,
        isError: true,
        data: action.payload,
      };
    default:
      throw new Error();
  }
};

const useApi = () => {
  const history = useHistory();
  let BASE_URL;
  let clientId;
  if (window.location.hostname.includes('localhost')) {
    // BASE_URL = 'http://localhost:7000';
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'T0ia5s2bhrac';
  } else if (window.location.hostname.includes('dev')) {
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'Tczabtzc0rac';
  } else if (window.location.hostname.includes('qa')) {
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'Tzej0fe2trac';
  } else if (window.location.hostname.includes('demo')) {
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'Tgnztm9b8rac';
  } else if (window.location.hostname.includes('rtls')) {
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'Tyxfb2r42rac';
  } else if (window.location.hostname.includes('web.app')) {
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'Tkvm16bsbrac';
  } else {
    BASE_URL = 'https://api.tagntrac.io';
    clientId = 'T0ia5s2bhrac';
  }

  const user = sessionStorage.getItem('user');
  const currentTime = Math.floor(Date.now() / 1000);
  if (user) {
    const tokenExpired = currentTime > JSON.parse(sessionStorage.user).expiration;
    if (tokenExpired) {
      axios({
        method: 'POST',
        url: `${BASE_URL}/refreshToken`,
        data: { refreshToken: JSON.parse(sessionStorage.user).refreshToken },
        headers: {
          Authorization: JSON.parse(sessionStorage.user).token,
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
        },
      }).then((data) => {
        data.data.response.user = JSON.parse(sessionStorage.user).user;
        data.data.response.organization = JSON.parse(sessionStorage.user).organization;
        data.data.response.project = JSON.parse(sessionStorage.user).project;
        data.data.response.clientApiKey = JSON.parse(sessionStorage.user).clientApiKey;
        sessionStorage.clear();
        sessionStorage.user = JSON.stringify(data.data.response);
        location.reload();
      });
      // .catch((err) => {
      //   sessionStorage.clear();
      //   history.replace('/');
      // });
    }
  }

  const [url, setUrl] = useState('');
  const [data, setData] = useState(null);
  const [method, setMethod] = useState('');

  const [state, dispatch] = useReducer(apiReducer, {
    isLoading: false,
    isError: false,
    data,
  });

  const setApiRequest = (url, method, data = null) => {
    let _url = url;
    if (_url === '/login') {
      _url = `${_url}?clientId=${clientId}`;
    }
    setMethod(method);
    setData(data);
    setUrl(BASE_URL + _url);
  };

  useEffect(() => {
    let didCancel = false;
    const clientApiKey = user && JSON.parse(sessionStorage.user).clientApiKey?.clientId;
    const callApi = async () => {
      dispatch({ type: 'INIT' });
      let result;
      try {
        if (url.includes('/login') || url.includes('/confirmPassword') || url.includes('/resetPassword')) {
          result = await axios({
            method,
            url,
            data,
            headers: {
              'Access-Control-Allow-Origin': '*',
            },
          });

          if (!didCancel) {
            dispatch({ type: 'SUCCESS', payload: result.data });
          }
        } else {
          result = await axios({
            method,
            url,
            data,
            headers: {
              Authorization: JSON.parse(sessionStorage.user).token,
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
              'X-Api-Key': clientApiKey,
            },
            config: {
              timeout: 25000,
            },
          });
          if (!didCancel) {
            dispatch({ type: 'SUCCESS', payload: result.data });
          }
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({
            type: 'FAILURE',
            payload:
              error?.response && error?.response?.data && error?.response?.data?.error
                ? error?.response?.data?.error
                : '',
          });
        }
      }
      setMethod('');
      setData(null);
      setUrl('');
    };

    if (url && method) callApi();

    return () => {
      didCancel = true;
    };
  }, [url, method, data]);

  return [state, setApiRequest];
};

export default useApi;
